import React from 'react';
import { number, string } from 'prop-types';
import { Avatar, Box, CircularProgress, Typography } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

// Utils
import { useTheme } from '@mui/material/styles';
import {
  avatarClassStyles,
  progressContainerStyles,
  progressIconStyles,
} from './CreateNewCommon.styles';

const SubmitProgressHeader = ({ copy, totalProgress }) => {
  const theme = useTheme();
  const boxStyles = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    height: 74,
    justifyContent: 'flex-start',
    mt: 1,
    mx: 'auto',
    pl: 6,
  };

  return (
    <Box {...boxStyles} bgcolor="surface.white" sx={{ ...progressContainerStyles(theme) }}>
      {totalProgress !== 100 ? (
        <>
          <CircularProgress color="secondary" size={24} sx={{ ...progressIconStyles(theme) }} />
          <Typography color="inherit" variant="h6">
            Total Progress&#8230; {totalProgress}%
          </Typography>
        </>
      ) : (
        <>
          <Avatar sx={{ ...avatarClassStyles(theme) }}>
            <CheckRoundedIcon />
          </Avatar>
          <Typography color="inherit" variant="h6">
            {copy}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default SubmitProgressHeader;

SubmitProgressHeader.propTypes = {
  copy: string,
  totalProgress: number.isRequired,
};

SubmitProgressHeader.defaultProps = {
  copy: 'All Setups Complete!',
};
